<div class="toolbar-container">
    <div class="toolbar-content">
        <h3>{{title}}</h3>
        <div class="toolbar-btn">
            <ng-content></ng-content>
        </div>
    </div>
    
</div>
